import * as React from "react";
import { Group } from "@vx/group";
import { LinePath } from "@vx/shape";
import { scaleTime, scaleLinear } from "@vx/scale";
import { curveMonotoneX, curveBasis, curveStep } from "@vx/curve";
import { max, min } from "d3-array";

export interface Props {
  data: number[];
  width: number;
  height: number;
}

const color = "#B9BFC7";

export default function MiniChart({ data, width, height }: Props) {
  const margin = {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  };

  // bounds
  const xMax = width - margin.left - margin.right;
  const yMax = height - margin.top - margin.bottom;
  let maxV = max(data);
  let minV = min(data);

  const yScale = scaleLinear<number>({
    rangeRound: [0, yMax],
    domain: [minV, maxV],
    nice: true
  });
  const xScale = scaleLinear<number>({
    domain: [0, data.length],
    clamp: true
  });

  const x = (d: number, n: number) => xScale(n);
  const y = (d: number) => yScale(d);

  xScale.range([0, xMax]);
  yScale.range([yMax, 0]);

  return (
    <svg width={width} height={height}>
      <Group top={margin.top} left={margin.left}>
        <LinePath data={data} x={x} y={y} stroke={color} strokeWidth={1} curve={curveBasis} />
      </Group>
    </svg>
  );
}
